import { Check } from 'lucide-react';

export function EditSectionFooter({
  saved,
  busy,
  canSave,
  saveLabel,
  error,
  note,
  onCancel,
  onSave,
}: {
  saved: boolean;
  busy: boolean;
  canSave: boolean;
  saveLabel?: string;
  error: string | null;
  /** Replaces the default reminder. Null shows no reminder at all. */
  note?: string | null;
  onCancel: () => void;
  onSave: () => void;
}) {
  const reminder =
    note === undefined
      ? saved
        ? 'Changes are logged to the audit trail.'
        : 'Saved once — edit later from this page. These rarely change.'
      : note;
  const primaryLabel = busy ? 'Saving…' : (saveLabel ?? (saved ? 'Save changes' : 'Save details'));
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 8,
        marginTop: 16,
        paddingTop: 12,
        borderTop: '1px dashed var(--nb-border)',
      }}
    >
      {error ? (
        <span
          role="alert"
          style={{ flex: 1, fontSize: 10.5, color: 'var(--nb-risk)', lineHeight: 1.4 }}
        >
          {error}
        </span>
      ) : (
        <span style={{ flex: 1, fontSize: 10.5, color: 'var(--nb-subtle)', lineHeight: 1.4 }}>
          {reminder}
        </span>
      )}
      {saved && (
        <button
          type="button"
          className="nb-btn nb-btn-ghost"
          onClick={onCancel}
          aria-disabled={busy}
        >
          Cancel
        </button>
      )}
      {canSave && (
        <button
          type="button"
          className="nb-btn nb-btn-primary"
          onClick={onSave}
          aria-disabled={busy}
          style={{ whiteSpace: 'nowrap' }}
        >
          <Check size={12} />
          {primaryLabel}
        </button>
      )}
    </div>
  );
}
